export enum EnvironmentType {
    Develop = 1,
    Qa,
    Production
}

export enum HeaderType {
    NoAuthenticate = 1,
    NoShowLoading,
    Pagination,
    Encryption
}

export enum EncryptionType {
    AES = 'AES-ENC',
    RSA = 'RSA-ENC',
    JWT = 'JWT-ENC',
    JWE = 'JWE-ENC'
}

export enum IconType {
    AweSomeFont = 1,
    Svg,
    SvgLocal
}

export enum OptionMenuType {
    Module = 1,
    SubModule,
    Screen,
    Function
}

export enum DataType {
    Text = 1,
    Number,
    Decimal,
    Boolean,
    Date,
    Email,
    URL
}

export enum ApiType {
    Security = 1,
    Rest,
    Sales,
}

export enum PlatformType {
    All = 1,
    Web,
    Movil,
}

export enum PermissionType {
    CovetableMaterialAdmin = 1,
    AdminGasolineVouchers = 2,
    AdminUserType = 3,
    AdminScreens = 4,
    AdminSubmodules = 5,
    AdminParameters = 6,
    AdminEmailLayout = 7,
    AdminUsers = 8,
    ProfilesAdmin = 9,
    AdminModules = 10,
    AdminSectors = 11,
    AdminProductTypes = 12,
    AdminSouvenirs = 14,
    RestorePasswords = 13,
    AdminDepartments = 19,
    AdminCompanies = 23,
    AdminBusinessCenters = 27,
    AdminVehicles = 31,
    AdminProjects = 35,
    AdminBudgets = 53
}

export enum ResponseStatusType {
    OK = 200,
    CREATED = 201,
    NO_CONTENT = 204,
    PARTIAL_CONTENT = 206,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500
}

export enum ResponseStatusMessageType {
    OK = "",
    NO_CONTENT = "La respuesta no devolvió contenido",
    PARTIAL_CONTENT = "Falta de información en la petición",
    BAD_REQUEST = "Ocurrió un error interno al realizar la petición",
    UNAUTHORIZED = "No tienes autorización para acceder al recurso",
    NOT_FOUND = "Información del servicio no encontrada",
    INTERNAL_SERVER_ERROR = "Error interno del servidor"
}


export enum UserFunctionsType {
    ChangePassword = 1,
    LogOut, LogOutMask
}

export enum Days{
    Sunday = 0,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
}

export enum Months{
    January = 0,
    February,
    March,
    April,
    May,
    June,
    July,
    August,
    September,
    October,
    November,
    December
}

export enum TipoIconoEnum
{
  None = 0,
  AweSomeFont,
  Svg,
  PNG,
  SvgLocal,
}



